module.exports = __webpack_public_path__ + "img/organigrama_2024_08.1ed16f5f.png";